var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{
    'sidebar-close': !_vm.getThemeMode.verticalSidebarDrawer
  },style:({
    background: _vm.$vuetify.theme.themes[_vm.theme].background,
    color: '#304156'
  })},[_c('side-bar',{attrs:{"app":""}}),_c('app-bar',{attrs:{"app":""}}),_c('base-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }